import styles from './categories.module.css';
import DefaultRow from '../layout/defalutRow/defalutRow';
import Main from '../layout/main/main';
const Categories = () => {
  return (
    <Main h="The Categories" activeIndex="1" className="sm5-active-section">
      <div className={styles.itemsGrid}>
        <DefaultRow mediaSrc="https://bucket.zhiyun-tech.com/detail/sm5challenge-narratives" className="sm5-active-fade-in-element">
          Tell a fictional or fictionalized story, event, romance love story, or
          narrative, drive us to tears, anguish, or pure suspense with a story
          from the heart, bring us into the fabricated scene you create.
        </DefaultRow>
        <DefaultRow mediaSrc="https://bucket.zhiyun-tech.com/detail/sm5challenge-mini-doc" className="sm5-active-fade-in-element">
          Record a true short film dedicated to instruction, education, or
          maintaining a historical record. Inform us, educate us, or provoke us
          to rethink.
        </DefaultRow>
        <DefaultRow mediaSrc="https://bucket.zhiyun-tech.com/detail/sm5challenge-adventure" className="sm5-active-fade-in-element">
          Take us through the forest, or deep down in the ocean, or climb up on
          the mountain high, record the journey you seek thrill on.
        </DefaultRow>
        <DefaultRow mediaSrc="https://bucket.zhiyun-tech.com/detail/sm5challenge-musicanddance" className="sm5-active-fade-in-element">
          Show us how you create the perfect combination of music and dance.
        </DefaultRow>
        <DefaultRow mediaSrc="https://bucket.zhiyun-tech.com/detail/sm5challenge-how-to" className="sm5-active-fade-in-element">
          Get creative with the content and format, don’t hesitate to show the
          audience how to do... anything!
        </DefaultRow>
      </div>
    </Main>
  );
};

export default Categories;
